module.exports = __webpack_public_path__ + "img/logo1 (1).a5873117.jpg";